import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import BaseDocumentCell from './BaseDocumentCell';

const EmptyCell = ({ colSpan = 2 }) => (
  <GridItem colSpan={colSpan}><Box /></GridItem>
);

EmptyCell.propTypes = { colSpan: PropTypes.number };

export default BaseDocumentCell(EmptyCell);
